import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix }) =>
  ({
    staticPageUrl: `${staticAssetPageUrl}/datawrapper${staticPageUrlSuffix}`,
  }) as const) satisfies ConfigFn

export default config
